import React from "react";
import TabFilter from "../App/TabFilter";
import { useState, useEffect, useRef } from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import {
  GetSelectedIDsFromList,
  SelectUnSelectSpecificElement,
  SortTheList,
} from "../Shared/Utility";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import DownloadPopup from "../App/DownloadPopup";
function TrendReport() {
  const navigate = useNavigate();
  var filterOptionsData = [
    [
      { Name: "Network", ID: "1" },
      { Name: "Sales", ID: "2" },
      { Name: "Aftersales", ID: "3" },
      { Name: "All", ID: "0" },
    ],
    [
      { Name: "Combined", ID: "0" },
      { Name: "KPI Level", ID: "1" },
    ],
    [
      { Name: "Monthly", ID: "0" },
      { Name: "Quarterly", ID: "1" },
    ],
    [
      { Name: "JLR", ID: "0" },
      { Name: "Jag", ID: "1" },
      { Name: "LR", ID: "2" },
    ],
    [
      { Name: "Retailer", ID: "0" },
      { Name: "Importer", ID: "1" },
    ],
    [
      { Name: "Approved", ID: "0" },
      { Name: "All", ID: "1" },
    ],
    [
      { Name: "Absolute", ID: "0" },
      { Name: "Comparative", ID: "1" },
    ],
  ];
  const [filters, setFilters] = useState<any>([
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "1",
    "0",
    "",
    "0",
    "YTD",
    "A",
  ]);
  const [filtersList, setFiltersList] = useState<any>({});
  const [yearsDataList, setYearsDataList] = useState([]);
  const [DID, setDID] = useState(0);
  const [columnFilterList, setColumnFilterList] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const [monthStatusData, setMonthStatusData] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [recordData, setRecordData] = useState([]);
  const [thisGridListData, setThisGridListData] = useState([]);
  const [finalGridData, setFinalGridData] = useState([]);
  const [appliedHeaderFilters, setAppliedHeaderFilters] = useState([]);
  const [maxTotals, setMaxTotals] = useState([0, 0, 0, 0, 0, 0]);
  const [showHideColumnNumberList, setShowHideColumnNumberList] = useState([
    2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
    23, 24,
  ]);
  const [approvedMonth, setApprovedMonth] = useState(0);
  const [lastUpdatedByText, setLastUpdatedByText] = useState("");
  const [typeID, setTypeID] = useState(0);
  const [typeName, setTypeName] = useState("");
  const [showAnimation, setShowAnimation] = useState(false);
  const [legendsText, setLegendsText] = useState({
    ScoreTop: "",
    ScoreMiddle: "",
    ScoreBottom: "",
  });

  const filtersListRef = useRef<any | null>(null);
  filtersListRef.current = filtersList;

  const recordDataRef = useRef<any | null>(null);
  recordDataRef.current = recordData;

  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;

  ///--States for columnFilter components---///
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [filterLists, setFilterLists] = useState([]);
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setSelectedColumnName(Name);
    }
  }
  //--States for columnFilter components---///

  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpFileURL, setPopUpFileURL] = useState("");
  const [popUpMessage, setPopUpMessage] = useState(
    "Data has been exported to file successfully.!"
  );
  function DownloadPopupCallBack() {
    setShowPopUp(false);
    setPopUpFileURL("");
  }

  useEffect(() => {
    getSavedFiltersTrendReport();
  }, []);

  useEffect(() => {
    if (reloadData) {
      loadTrendReportData(false);
      setReloadData(false);
    }
  }, [reloadData]);

  function getSavedFiltersTrendReport() {
    let object = {} as any;
    object.appid = AppContext.App;
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFIRSFactorKey/GetSavedFiltersTrendReport",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setYearsDataList(l_response[0]);
          setFiltersList(l_response[1]);
          setDID(l_response[2][0].DID);

          filtersListRef.current = l_response[1];

          let l_filter: any = filters;
          for (let i = 0; i < 10; i++) {
            l_filter[i] = l_response[1][0]["Index" + i + "Val"];
          }
          if (DID > 0) {
            l_filter[6] = "1"; //Approved
          }

          setFilters(l_filter);
          SetColumnsVisibilityFilters(
            filtersListRef.current[0].HideColumns,
            "chkShowHideColumn",
            "tblData"
          );
          setReloadData(true);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function handleTabFilterCallback(TabFilterData: any) {
    filters[10] = "YTD";
    filters[11] = "D";
    setColumnFilterList(false);
    let ID = TabFilterData.ID;
    let Type = TabFilterData.Type;
    let l_filter: any = filters;
    l_filter[Type] = ID;
    setFilters(l_filter);
    saveFiltersTrendReport(l_filter);

    if (Type === 2) {
      SetMonthAndQuarterView("tblData");
    } else {
      loadTrendReportData(false);
    }
  }

  function saveFiltersTrendReport(filterData: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.index0val = filterData[0];
    object.index1val = filterData[1];
    object.index2val = filterData[2];
    object.index3val = filterData[3];
    object.index4val = filterData[4];
    object.index5val = filterData[5];
    object.index6val = filterData[6];
    object.index7val = filterData[7];
    object.hidecolumns = filtersListRef.current[0].HideColumns; //"15,16,18,19,22" ;
    for (var i = 0; i < 10; i++) {
      filtersList[0]["Index" + i + "Val"] = filterData[i];
    }

    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFIRSFactorKey/SaveFiltersTrendReport",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function loadTrendReportData(refesh: boolean = false) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.refresh = refesh;
    object.year = filters[3];
    object.section = filters[0];
    object.combinedorkpi = filters[1];
    object.monthlyorquarterly = filters[2];
    object.brandid = filters[4];
    object.retailerorimporter = filters[5];
    object.approved = filters[6];
    object.rankingtype = filters[7];
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFIRSFactorKey/LoadTrendReportData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          setShowAnimation(false);
          let l_response = response.data.Data;
          setRecordData(l_response);
          setStatusData(l_response[0]);
          setMonthStatusData(l_response[1]);
          setGridData(l_response[2]);
          setRefreshFilters(!refreshFilters);

          filters[10] = "YTD";
          filters[11] = "D";

          recordDataRef.current = l_response;

          if (l_response[1][0].MarStatus == 3) setApprovedMonth(3);
          else if (l_response[1][0].FebStatus == 3) setApprovedMonth(2);
          else if (l_response[1][0].JanStatus == 3) setApprovedMonth(1);
          else if (l_response[1][0].DecStatus == 3) setApprovedMonth(12);
          else if (l_response[1][0].NovStatus == 3) setApprovedMonth(11);
          else if (l_response[1][0].OctStatus == 3) setApprovedMonth(10);
          else if (l_response[1][0].SepStatus == 3) setApprovedMonth(9);
          else if (l_response[1][0].AugStatus == 3) setApprovedMonth(8);
          else if (l_response[1][0].JulStatus == 3) setApprovedMonth(7);
          else if (l_response[1][0].JunStatus == 3) setApprovedMonth(6);
          else if (l_response[1][0].MayStatus == 3) setApprovedMonth(5);
          else if (l_response[1][0].AprStatus == 3) setApprovedMonth(4);

          let l_MaxTotals = maxTotals;
          l_MaxTotals[0] = l_response[0][0].MaxScore;
          l_MaxTotals[1] = l_response[0][0].Q1Max;
          l_MaxTotals[2] = l_response[0][0].Q2Max;
          l_MaxTotals[3] = l_response[0][0].Q3Max;
          l_MaxTotals[4] = l_response[0][0].Q4Max;
          l_MaxTotals[5] = l_response[0][0].YTDMax;
          setMaxTotals(l_MaxTotals);

          setLegendsText({
            ScoreTop: l_response[0][0].ScoreTop,
            ScoreMiddle: l_response[0][0].ScoreMiddle,
            ScoreBottom: l_response[0][0].ScoreBottom,
          });

          setThisGridListData(l_response[2]);
          thisGridListDataRef.current = l_response[2];

          setLastUpdatedByText(
            "Last updated by " +
              l_response[1][0].UserName +
              " on " +
              l_response[1][0].ChangeDateCalc
          );

          HandleSortAndLoadData();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
          setShowAnimation(false);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setShowAnimation(false);
      });
  }

  function getAllFilterdLists(FilterLists: any) {
    setFilterLists(FilterLists);
  }

  function downloadGridData(All: number) {
    let l_filterLists = filterLists as any;
    var FiltersSelected = {
      Market: "-1",
      Importer: "-1",
      Retailer: "-1",
      RT: "-1",
      FIMSCode: "-1",
      KPI: "-1",
    };
    if (All === 0) {
      if (l_filterLists && l_filterLists != null && l_filterLists.length > 0) {
        for (let i = 0; i < l_filterLists.length; i++) {
          for (let j = 0; j < l_filterLists[i].List.length; j++) {
            if (l_filterLists[i].Name === "MarketName") {
              if (l_filterLists[i].List[j].IsSelected === true) {
                FiltersSelected.Market += "|" + l_filterLists[i].List[j].Name;
              }
            } else if (l_filterLists[i].Name === "DealerName") {
              if (l_filterLists[i].List[j].IsSelected === true) {
                FiltersSelected.Importer += "|" + l_filterLists[i].List[j].Name;
              }
            } else if (l_filterLists[i].Name === "FacilityName") {
              if (l_filterLists[i].List[j].IsSelected === true) {
                FiltersSelected.Retailer += "|" + l_filterLists[i].List[j].Name;
              }
            } else if (l_filterLists[i].Name === "FacilityTypeName") {
              if (l_filterLists[i].List[j].IsSelected === true) {
                FiltersSelected.RT += "|" + l_filterLists[i].List[j].Name;
              }
            } else if (l_filterLists[i].Name === "FIMSCode") {
              if (l_filterLists[i].List[j].IsSelected === true) {
                FiltersSelected.FIMSCode += "|" + l_filterLists[i].List[j].Name;
              }
            } else if (l_filterLists[i].Name === "KPIName") {
              if (l_filterLists[i].List[j].IsSelected === true) {
                FiltersSelected.KPI += "|" + l_filterLists[i].List[j].Name;
              }
            }

            // var ThisFilter = AppliedHeaderFilters[i];
            // var ListOfParams = ThisFilter.split(':');
            // if (ListOfParams.length == 2) {
            //     if (ListOfParams[0] == 'FIMS Code') {
            //         FiltersSelected.FIMSCode += '|' + ListOfParams[1].trim();
            //     }
            //     else {
            //         FiltersSelected[ListOfParams[0]] += '|' + ListOfParams[1].trim();
            //     }
            // }
          }
        }
      }
    }

    getDownlaodTrendReportData(FiltersSelected);
  }

  function getDownlaodTrendReportData(FiltersSelected: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.refresh = false;
    object.year = filters[3];
    object.section = filters[0];
    object.combinedorkpi = filters[1];
    object.monthlyorquarterly = filters[2];
    object.brandid = filters[4];
    object.retailerorimporter = filters[5];
    object.approved = filters[6];
    object.rankingtype = filters[7];
    object.market = FiltersSelected.Market;
    object.importer = FiltersSelected.Importer;
    object.facility = FiltersSelected.Retailer;
    object.ft = FiltersSelected.RT;
    object.fimscode = FiltersSelected.FIMSCode;
    object.kpi = FiltersSelected.KPI;
    object.type = 3;

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFIRSFactorKey/GetDownlaodTrendReportData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          let link = l_response[0][0].DownloadData;
          if (l_response[0][0].Status === 1) {
            setPopUpFileURL(link);
            setShowPopUp(true);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    setGetFilteredLists(!getFilteredLists);
    thisGridListDataRef.current = FilterData;
    HandleSortAndLoadData();
  }

  function HandleSortAndLoadData() {
    if (filters[10] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[10],
        filters[11]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    HandleFactorKeyListItems(GridData, DID);
  }

  function HandleFactorKeyListItems(ThisListData: any, LoggedInDealerID: any) {
    let rank = 0;
    for (var k = 0; k < ThisListData.length; k++) {
      if (ThisListData[k].DealerName === "MENA Average") {
        ThisListData[k].Rank = 0;
      } else {
        rank += 1;
        ThisListData[k].Rank = rank;
      }
    }

    let data: any = [...ThisListData];
    setThisGridListData(data);
    var TypeID = 0;
    var TypeName = "";

    if (filters[1] == 1) {
      // KPI Level
      if (filters[4] > 0) {
        TypeID = 1;
        TypeName = "KPI-Brand-Level";
      }
      if (filters[4] == 0) {
        TypeID = 2;
        TypeName = "KPI-JLR-Level";
      }
    } else {
      // Combined Level
      if (filters[4] > 0) {
        TypeID = 3;
        TypeName = "Combined-Brand-Level";
      }
      if (filters[4] == 0) {
        TypeID = 4;
        TypeName = "Combined-JLR-Level";
      }
    }

    setTypeID(TypeID);
    setTypeName(TypeName);
    // MakeSecondHeaderRow(TypeID);

    // var l_strClass = "ScoreCategoryG";
    // var l_intRank = 0;

    // for (var k = 0; k < ThisListData.length; k++) {
    //   var boolLoggedInUserData = false;
    //   if (LoggedInDealerID == ThisListData[k].DealerID)
    //     boolLoggedInUserData = true;

    //   l_strClass = "ScoreCategory" + ThisListData[k].RankYTDCL;

    //   if (Filters[1] == 1 || Filters[1] == 2) {
    //     PTSetVisibilty("spnInActiveOut", false);
    //     PTSetVisibilty("spnTopPerOut", false);
    //     PTSetVisibilty("spnMiddlePerOut", false);
    //     PTSetVisibilty("spnBottomPerOut", false);
    //   } else {
    //     PTSetVisibilty("spnInActiveOut", true);
    //     PTSetVisibilty("spnTopPerOut", true);
    //     PTSetVisibilty("spnMiddlePerOut", true);
    //     PTSetVisibilty("spnBottomPerOut", true);
    //   }

    //   if (ThisListData[k].DealerName != "MENA Average")
    //     l_intRank = l_intRank + 1;

    //   if (TypeID == 1 || TypeID == 2) {
    //     // KPI Level
    //     l_strClass = "";
    //   }

    //   CreateScoreEnteryEntery(
    //     l_intRank,
    //     l_strClass,
    //     boolLoggedInUserData,
    //     ThisListData[k],
    //     TypeID,
    //     TypeName
    //   );
    // }

    // $('[data-toggle="tooltip"]').tooltip({
    //   placement: "bottom",
    // });

    //AR:: Set Sorting
    SetSortingImage();

    SetColumnsVisibilityFilters(
      filtersListRef.current[0].HideColumns,
      "chkShowHideColumn",
      "tblData"
    );
  }

  ////  Sorting Starts    /////
  function SetSortingImage() {
    let imgSortApr: any = document.getElementById("imgSortApr");
    imgSortApr.innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortMay") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortMayVR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortJun") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortJunVR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortJul") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortJulVR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortAug") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortAugVR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortSep") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortSepVR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortOct") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortOctVR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortNov") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortNovVR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortDec") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortDecVR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortJan") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortJanVR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortFeb") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortFebVR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortMar") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortMarVR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortQ1") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortQ2") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortQ2VR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortQ3") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortQ3VR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortQ3VR2") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortQ4") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortQ4VR") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortQ4VR2") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortYTD") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="13px" height="15px" alt="B"/>';
    if (filters[11] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="13px" height="15px" alt="B"/>';
    }
    if (filters[10] != "")
      (
        document.getElementById("imgSort" + filters[10]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[10];
    var l_strSortDirection = filters[11];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[11] = "A";
      } else {
        filters[11] = "D";
      }
    } else {
      filters[11] = "D";
    }
    filters[10] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  ////  Sorting Ends    ////

  //////////// AR: Show Hide Table nth column --- Starts/////////

  function SetVisibilityNthColumn(
    tblName: any,
    chkID: any,
    p_intIndex: any,
    chkShowHideColumn: any
  ) {
    let l_element = document.getElementById(chkID) as any;

    if (l_element.checked) {
      $("#" + tblName + " th:nth-child(" + p_intIndex + ")").show();
      $("#" + tblName + " td:nth-child(" + p_intIndex + ")").show();
    } else {
      $("#" + tblName + " th:nth-child(" + p_intIndex + ")").hide();
      $("#" + tblName + " td:nth-child(" + p_intIndex + ")").hide();
    }

    if (chkShowHideColumn != null && chkShowHideColumn != "undefined")
      SaveTableColumnConfiguration(chkShowHideColumn);
  }

  function SaveTableColumnConfiguration(chkShowHideColumn: any) {
    var l_strColumns = GetSelectedIDsFromList(chkShowHideColumn);
    var SelectedColumns: any = l_strColumns.split(",");
    var HiddenColumnList = "";
    var Count = 0;
    for (var i = 0; i < showHideColumnNumberList.length; i++) {
      var ThisCol = showHideColumnNumberList[i];
      for (var k = 0; k < SelectedColumns.length; k++) {
        if (SelectedColumns[k] == ThisCol) {
          ThisCol = -1;
        }
      }

      if (ThisCol > -1) {
        if (Count == 0) HiddenColumnList = String(ThisCol);
        else HiddenColumnList += "," + String(ThisCol);
        Count += 1;
      }
    }
    filtersListRef.current[0].HideColumns = HiddenColumnList;
    saveFiltersTrendReport(filtersListRef.current[0]);
    SetMonthAndQuarterView("tblData");
  }

  function SetColumnsVisibilityFilters(
    p_strColumnIndesxesList: any,
    chkShowHideColumn: any,
    tblData: any
  ) {
    var SelectedColumns = p_strColumnIndesxesList.split(",");
    for (var i = 0; i < showHideColumnNumberList.length; i++) {
      var ShowCol = true;
      for (var k = 0; k < SelectedColumns.length; k++) {
        if (SelectedColumns[k] == showHideColumnNumberList[i]) {
          ShowCol = false;
        }
      }
      SelectUnSelectSpecificElement(
        chkShowHideColumn,
        showHideColumnNumberList[i],
        ShowCol
      );
    }
    MaintainColumnsVisibilityFilters(chkShowHideColumn, tblData);
    SetMonthAndQuarterView(tblData);
  }

  function MaintainColumnsVisibilityFilters(
    chkShowHideColumn: any,
    tblData: any
  ) {
    //AR:: Now set Visibility for the selected ones and hide all others
    var l_strList: any = document.getElementsByName(chkShowHideColumn);
    for (var i = 0, length = l_strList.length; i < length; i++) {
      if (!l_strList[i].checked)
        ShowHideNthColumnWithCompleteIDFilters(
          tblData,
          l_strList[i],
          l_strList[i].value
        );
    }
  }

  function ShowHideNthColumnWithCompleteIDFilters(
    tblName: any,
    chkID: any,
    p_intIndex: any
  ) {
    if (chkID.checked) {
      $("#" + tblName + " th:nth-child(" + p_intIndex + ")").show();
      $("#" + tblName + " td:nth-child(" + p_intIndex + ")").show();
    } else {
      $("#" + tblName + " th:nth-child(" + p_intIndex + ")").hide();
      $("#" + tblName + " td:nth-child(" + p_intIndex + ")").hide();
    }
  }

  ///////**** Show Hide Monthly and Quarterly******/////
  function SetMonthAndQuarterView(tblData: any) {
    var MonthlyColus = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
    var QuarterlyColus = [20, 21, 22, 23];
    var HiddenColumns = filtersListRef.current[0].HideColumns;
    var HiddenColumnsList = HiddenColumns.split(",");

    if (filters[2] == "0") {
      for (var i = 0; i < MonthlyColus.length; i++) {
        // Check if already hidden from Show/Hide column main functionality.. then dont show
        var ShowCol = true;
        for (var k = 0; k < HiddenColumnsList.length; k++) {
          if (MonthlyColus[i] == HiddenColumnsList[k]) {
            ShowCol = false;
          }
        }
        if (ShowCol) {
          $("#" + tblData + " th:nth-child(" + MonthlyColus[i] + ")").show();
          $("#" + tblData + " td:nth-child(" + MonthlyColus[i] + ")").show();
        }
      }
      for (var i = 0; i < QuarterlyColus.length; i++) {
        $("#" + tblData + " th:nth-child(" + QuarterlyColus[i] + ")").hide();
        $("#" + tblData + " td:nth-child(" + QuarterlyColus[i] + ")").hide();
      }
    } else {
      for (var i = 0; i < MonthlyColus.length; i++) {
        $("#" + tblData + " th:nth-child(" + MonthlyColus[i] + ")").hide();
        $("#" + tblData + " td:nth-child(" + MonthlyColus[i] + ")").hide();
      }
      for (var i = 0; i < QuarterlyColus.length; i++) {
        // Check if already hidden from Show/Hide column main functionality.. then dont show
        var ShowCol = true;
        for (var k = 0; k < HiddenColumnsList.length; k++) {
          if (QuarterlyColus[i] == HiddenColumnsList[k]) {
            ShowCol = false;
          }
        }
        if (ShowCol) {
          $("#" + tblData + " th:nth-child(" + QuarterlyColus[i] + ")").show();
          $("#" + tblData + " td:nth-child(" + QuarterlyColus[i] + ")").show();
        }
      }
    }
  }
  ///////**** Show Hide Monthly and Quarterly******/////

  //////////// AR: Show Hide Table nth column --- Ends/////////

  function viewRetailerScorecardScreen(
    PFIDealerID: any,
    PFIAPOFacilityID: any,
    PFIBrandID: any,
    SectionID: any,
    ApprovedMonth: any,
    NumericYear: any
  ) {
    console.log(
      PFIDealerID +
        "," +
        PFIAPOFacilityID +
        "," +
        PFIBrandID +
        "," +
        SectionID +
        "," +
        ApprovedMonth +
        "," +
        NumericYear
    );

    AppContext.ScoreCardFiltersIDs = {
      ScreenID: 0,
      Dealers: PFIDealerID,
      Facilities: PFIAPOFacilityID,
      Years: NumericYear,
      Months: ApprovedMonth,
      Brand: PFIBrandID,
    };

    navigate("/retailerscorecard");

    //redirect it to retailerscorecard
  }

  return (
    <div className="page--contents">
      {showAnimation && <LoadingAnimation />}
      <DownloadPopup
        ShowPopup={showPopUp}
        FileLink={popUpFileURL}
        Message={popUpMessage}
        DownloadPopupCallBack={DownloadPopupCallBack}
      />
      <div className="page--breadcrumb">
        <a>Trend Report</a>
      </div>
      <div className="page--data">
        <div className="flex-container">
          <div className="flex-items">
            <select
              className="input-field select-field"
              defaultValue={filters[3]}
              onChange={(e) =>
                handleTabFilterCallback({ ID: e.target.value, Type: 3 })
              }
            >
              {yearsDataList &&
                yearsDataList.map((Item: any, index) => (
                  <option
                    value={Item.PID}
                    key={Item.PID}
                    selected={filters[3] == Item.PID}
                  >
                    {Item.Name}
                  </option>
                ))}
            </select>

            <TabFilter
              DataType={0}
              SelectedValue={filters[0]}
              DataList={filterOptionsData[0]}
              TabFilterCallback={handleTabFilterCallback}
            />
            <TabFilter
              DataType={1}
              SelectedValue={filters[1]}
              DataList={filterOptionsData[1]}
              TabFilterCallback={handleTabFilterCallback}
            />
            <TabFilter
              DataType={2}
              SelectedValue={filters[2]}
              DataList={filterOptionsData[2]}
              TabFilterCallback={handleTabFilterCallback}
            />
            <TabFilter
              DataType={4}
              SelectedValue={filters[4]}
              DataList={filterOptionsData[3]}
              TabFilterCallback={handleTabFilterCallback}
            />
            <TabFilter
              DataType={5}
              SelectedValue={filters[5]}
              DataList={filterOptionsData[4]}
              TabFilterCallback={handleTabFilterCallback}
            />
            {DID === 0 && (
              <TabFilter
                DataType={6}
                SelectedValue={filters[6]}
                DataList={filterOptionsData[5]}
                TabFilterCallback={handleTabFilterCallback}
              />
            )}
            <TabFilter
              DataType={7}
              SelectedValue={filters[7]}
              DataList={filterOptionsData[6]}
              TabFilterCallback={handleTabFilterCallback}
            />
          </div>
          <div className="view-list">
            <a
              className="btn-primary"
              onClick={() => {
                setColumnFilterList(!columnFilterList);
              }}
            >
              <img src="images/eye.svg" width="16px" height="15px" alt="eye" />
            </a>
            <div
              className={`check-list ${
                columnFilterList === false ? "no-display" : ""
              }`}
            >
              <a
                className="btn-close"
                onClick={() => {
                  setColumnFilterList(false);
                }}
              >
                Close
              </a>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn2"
                  name="chkShowHideColumn"
                  value="2"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn2",
                      "2",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Market</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn3"
                  name="chkShowHideColumn"
                  value="3"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn3",
                      "3",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Importer</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn4"
                  name="chkShowHideColumn"
                  value="4"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn4",
                      "4",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Retailer</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn5"
                  name="chkShowHideColumn"
                  value="5"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn5",
                      "5",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Retailer Type</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn6"
                  name="chkShowHideColumn"
                  value="6"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn6",
                      "6",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>FIMS Code</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn7"
                  name="chkShowHideColumn"
                  value="7"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn7",
                      "7",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>KPI</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn8"
                  name="chkShowHideColumn"
                  value="8"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn8",
                      "8",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Apr</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn9"
                  name="chkShowHideColumn"
                  value="9"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn9",
                      "9",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>May</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn10"
                  name="chkShowHideColumn"
                  value="10"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn10",
                      "10",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Jun</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn11"
                  name="chkShowHideColumn"
                  value="11"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn11",
                      "11",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Jul</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn12"
                  name="chkShowHideColumn"
                  value="12"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn12",
                      "12",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Aug</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn13"
                  name="chkShowHideColumn"
                  value="13"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn13",
                      "13",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Sep</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn14"
                  name="chkShowHideColumn"
                  value="14"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn14",
                      "14",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Oct</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn15"
                  name="chkShowHideColumn"
                  value="15"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn15",
                      "15",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Nov</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn16"
                  name="chkShowHideColumn"
                  value="16"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn16",
                      "16",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Dec</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn17"
                  name="chkShowHideColumn"
                  value="17"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn17",
                      "17",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Jan</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn18"
                  name="chkShowHideColumn"
                  value="18"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn18",
                      "18",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Feb</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn19"
                  name="chkShowHideColumn"
                  value="19"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn19",
                      "19",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Mar</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn20"
                  name="chkShowHideColumn"
                  value="20"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn20",
                      "20",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Q1</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn21"
                  name="chkShowHideColumn"
                  value="21"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn21",
                      "21",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Q2</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn22"
                  name="chkShowHideColumn"
                  value="22"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn22",
                      "22",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Q3</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn3"
                  name="chkShowHideColumn"
                  value="23"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn23",
                      "23",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>Q4</span>
              </div>
              <div className="check-item">
                <input
                  type="checkbox"
                  id="chkShowHideColumn24"
                  name="chkShowHideColumn"
                  value="24"
                  onClick={() =>
                    SetVisibilityNthColumn(
                      "tblData",
                      "chkShowHideColumn24",
                      "24",
                      "chkShowHideColumn"
                    )
                  }
                />
                <span>YTD</span>
              </div>
            </div>
          </div>
        </div>
        <div className="section-table">
          <div className="legends-buttons">
            {typeID >= 3 && (
              <>
                <div className="single-legend">
                  <p>{legendsText.ScoreTop}</p>
                  <span className="legend-1"></span>
                </div>
                <div className="single-legend">
                  <p>{legendsText.ScoreMiddle} </p>
                  <span className="legend-2"></span>
                </div>
                <div className="single-legend">
                  <p>{legendsText.ScoreBottom}</p>
                  <span className="legend-3"></span>
                </div>
                <div className="single-legend">
                  <p>INACTIVE</p>
                  <span className="legend-4"></span>
                </div>
              </>
            )}
            <a
              className="btn-primary"
              title="Download all data"
              onClick={() => downloadGridData(1)}
            >
              <img
                src="images/download.svg"
                width="13px"
                height="15px"
                alt="download"
              />
            </a>
            <a
              className="btn-primary"
              title="Download filter data"
              onClick={() => downloadGridData(0)}
            >
              <img
                src="images/export.png"
                width="13px"
                height="15px"
                alt="export"
              />
            </a>
            {DID === 0 && (
              <a
                className="btn-primary"
                title={lastUpdatedByText}
                onClick={() => loadTrendReportData(true)}
              >
                <img
                  src="images/refresh.svg"
                  width="13px"
                  height="15px"
                  alt="refresh"
                />
              </a>
            )}
          </div>

          <ColumnFilterCheckboxList
            DataType={1}
            RefreshFilters={refreshFilters}
            GridData={gridData}
            ColumnName={selectedColumnName}
            ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
            GetFilteredLists={getFilteredLists}
            ReturnAllFilterdLists={getAllFilterdLists}
            ClickPosition={clickPosition}
            Orientation={"Center"}
            ColumnOrientation={[
              { Name: "MarketName", Orientation: "Right" },
              { Name: "DealerName", Orientation: "Right" },
            ]}
          />

          <div className="table-scroll">
            <table className="part-head trend-table" id="tblData">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>
                    <span
                      onClick={(e) => ShowColumnFilterList(e, "MarketName")}
                      data-function="ShowColumnFilterList"
                    >
                      Market
                    </span>
                  </th>
                  <th>
                    <span
                      onClick={(e) => ShowColumnFilterList(e, "DealerName")}
                      data-function="ShowColumnFilterList"
                    >
                      Importer
                    </span>
                  </th>
                  <th>
                    <span
                      onClick={(e) => ShowColumnFilterList(e, "FacilityName")}
                      data-function="ShowColumnFilterList"
                    >
                      Retailer
                    </span>
                  </th>
                  <th>
                    <span
                      onClick={(e) =>
                        ShowColumnFilterList(e, "FacilityTypeName")
                      }
                      data-function="ShowColumnFilterList"
                    >
                      RT
                    </span>
                  </th>
                  <th>
                    <span
                      onClick={(e) => ShowColumnFilterList(e, "FIMSCode")}
                      data-function="ShowColumnFilterList"
                    >
                      FIMS Code
                    </span>
                  </th>
                  <th className="b-black">
                    <span
                      onClick={(e) => ShowColumnFilterList(e, "KPIName")}
                      data-function="ShowColumnFilterList"
                    >
                      KPI
                    </span>
                  </th>
                  <th className="b-black">Apr</th>
                  <th className="b-black">May</th>
                  <th className="b-black">Jun</th>
                  <th className="b-black">Jul</th>
                  <th className="b-black">Aug</th>
                  <th className="b-black">Sep</th>
                  <th className="b-black">Oct</th>
                  <th className="b-black">Nov</th>
                  <th className="b-black">Dec</th>
                  <th className="b-black">Jan</th>
                  <th className="b-black">Feb</th>
                  <th className="b-black">Mar</th>
                  <th className="b-black">Q1</th>
                  <th className="b-black">Q2</th>
                  <th className="b-black">Q3</th>
                  <th className="b-black">Q4</th>
                  <th>YTD</th>
                </tr>
              </thead>
              <tbody>
                <tr id="td9999978">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="b-black"></td>
                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-2" : "cl-col-1"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Apr")}
                          title="Sort By Score"
                        >
                          <span id="imgSortApr"></span>
                        </a>
                      </span>
                    </div>
                  </td>

                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-3" : "cl-col-2"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("May")}
                          title="Sort By Score"
                        >
                          <span id="imgSortMay">
                            <i className="glyphicon glyphicon-triangle-bottom ArrangeGrid"></i>
                          </span>
                        </a>
                      </span>
                      <span>
                        Var
                        <a
                          onClick={() => LoadWithSelectedSort("MayVR")}
                          title="Sort By Var"
                        >
                          <span id="imgSortMayVR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-3" : "cl-col-2"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Jun")}
                          title="Sort By Score"
                        >
                          <span id="imgSortJun"></span>
                        </a>
                      </span>
                      <span>
                        Var
                        <a
                          onClick={() => LoadWithSelectedSort("JunVR")}
                          title="Sort By Var"
                        >
                          <span id="imgSortJunVR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-3" : "cl-col-2"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Jul")}
                          title="Sort By Score"
                        >
                          <span id="imgSortJul"></span>
                        </a>
                      </span>
                      <span>
                        Var
                        <a
                          onClick={() => LoadWithSelectedSort("JulVR")}
                          title="Sort By Var"
                        >
                          <span id="imgSortJulVR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-3" : "cl-col-2"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Aug")}
                          title="Sort By Score"
                        >
                          <span id="imgSortAug"></span>
                        </a>
                      </span>
                      <span>
                        Var
                        <a
                          onClick={() => LoadWithSelectedSort("AugVR")}
                          title="Sort By Var"
                        >
                          <span id="imgSortAugVR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-3" : "cl-col-2"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Sep")}
                          title="Sort By Score"
                        >
                          <span id="imgSortSep"></span>
                        </a>
                      </span>
                      <span>
                        Var
                        <a
                          onClick={() => LoadWithSelectedSort("SepVR")}
                          title="Sort By Var"
                        >
                          <span id="imgSortSepVR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-3" : "cl-col-2"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Oct")}
                          title="Sort By Score"
                        >
                          <span id="imgSortOct"></span>
                        </a>
                      </span>
                      <span>
                        Var
                        <a
                          onClick={() => LoadWithSelectedSort("OctVR")}
                          title="Sort By Var"
                        >
                          <span id="imgSortOctVR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-3" : "cl-col-2"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Nov")}
                          title="Sort By Score"
                        >
                          <span id="imgSortNov"></span>
                        </a>
                      </span>
                      <span>
                        Var
                        <a
                          onClick={() => LoadWithSelectedSort("NovVR")}
                          title="Sort By Var"
                        >
                          <span id="imgSortNovVR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-3" : "cl-col-2"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Dec")}
                          title="Sort By Score"
                        >
                          <span id="imgSortDec"></span>
                        </a>
                      </span>
                      <span>
                        Var
                        <a
                          onClick={() => LoadWithSelectedSort("DecVR")}
                          title="Sort By Var"
                        >
                          <span id="imgSortDecVR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-3" : "cl-col-2"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Jan")}
                          title="Sort By Score"
                        >
                          <span id="imgSortJan"></span>
                        </a>
                      </span>
                      <span>
                        Var
                        <a
                          onClick={() => LoadWithSelectedSort("JanVR")}
                          title="Sort By Var"
                        >
                          <span id="imgSortJanVR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-3" : "cl-col-2"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Feb")}
                          title="Sort By Score"
                        >
                          <span id="imgSortFeb"></span>
                        </a>
                      </span>
                      <span>
                        Var
                        <a
                          onClick={() => LoadWithSelectedSort("FebVR")}
                          title="Sort By Var"
                        >
                          <span id="imgSortFebVR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div
                      className={`flex-div ${
                        typeID === 1 ? "cl-col-3" : "cl-col-2"
                      }`}
                    >
                      {typeID === 1 && <span>Input</span>}
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Mar")}
                          title="Sort By Score"
                        >
                          <span id="imgSortMar"></span>
                        </a>
                      </span>
                      <span>
                        Var
                        <a
                          onClick={() => LoadWithSelectedSort("MarVR")}
                          title="Sort By Var"
                        >
                          <span id="imgSortMarVR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div className="flex-div cl-col-1">
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Q1")}
                          title="Sort By Score"
                        >
                          <span id="imgSortQ1"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div className="flex-div cl-col-2">
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Q2")}
                          title="Sort By Score"
                        >
                          <span id="imgSortQ2"></span>
                        </a>
                      </span>
                      <span>
                        Q2-Q1
                        <a
                          onClick={() => LoadWithSelectedSort("Q2VR")}
                          title="Sort By Q2-Q1"
                        >
                          <span id="imgSortQ2VR"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div className="flex-div cl-col-3">
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Q3")}
                          title="Sort By Score"
                        >
                          <span id="imgSortQ3"></span>
                        </a>
                      </span>
                      <span>
                        Q3-Q2
                        <a
                          onClick={() => LoadWithSelectedSort("Q3VR")}
                          title="Sort By Q3-Q2"
                        >
                          <span id="imgSortQ3VR"></span>
                        </a>
                      </span>
                      <span>
                        Q3-Q1
                        <a
                          onClick={() => LoadWithSelectedSort("Q3VR2")}
                          title="Sort By Q3-Q1"
                        >
                          <span id="imgSortQ3VR2"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td b-black">
                    <div className="flex-div cl-col-3">
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("Q4")}
                          title="Sort By Score"
                        >
                          <span id="imgSortQ4"></span>
                        </a>
                      </span>
                      <span>
                        Q4-Q3
                        <a
                          onClick={() => LoadWithSelectedSort("Q4VR")}
                          title="Sort By Q4-Q3"
                        >
                          <span id="imgSortQ4VR"></span>
                        </a>
                      </span>
                      <span>
                        Q4-Q1
                        <a
                          onClick={() => LoadWithSelectedSort("Q4VR2")}
                          title="Sort By Q4-Q1"
                        >
                          <span id="imgSortQ4VR2"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                  <td className="flex-td">
                    <div className="flex-div cl-col-1">
                      <span>
                        Score
                        <a
                          onClick={() => LoadWithSelectedSort("YTD")}
                          title="Sort By Score"
                        >
                          <span id="imgSortYTD"></span>
                        </a>
                      </span>
                    </div>
                  </td>
                </tr>

                {filters[0] === 0 && (
                  <tr id="td9999979">
                    <td className="cl-EmptyTd">
                      <span>
                        <b>Max</b>
                      </span>
                    </td>
                    <td className="cl-EmptyTd">
                      <span>
                        <b></b>
                      </span>
                    </td>
                    <td className="cl-EmptyTd">
                      <span>
                        <b></b>
                      </span>
                    </td>
                    <td className="cl-EmptyTd">
                      <span>
                        <b></b>
                      </span>
                    </td>
                    <td className="cl-EmptyTd">
                      <span>
                        <b></b>
                      </span>
                    </td>
                    <td className="cl-EmptyTd">
                      <span>
                        <b></b>
                      </span>
                    </td>
                    <td className="cl-EmptyTd">
                      <span>
                        <b></b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[0]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[1]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[2]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[3]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[4]}</b>
                      </span>
                    </td>
                    <td className="cl-MaxNumber">
                      <span>
                        <b>{maxTotals[5]}</b>
                      </span>
                    </td>
                  </tr>
                )}

                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={item.Rank}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.Rank === 0 ? "-" : item.Rank}</td>
                          <td>{item.MarketName}</td>
                          <td
                            onClick={() =>
                              viewRetailerScorecardScreen(
                                item.PFIDealerID,
                                item.PFIAPOFacilityID,
                                item.PFIBrandID,
                                item.SectionID,
                                approvedMonth,
                                item.NumericYear
                              )
                            }
                          >
                            {item.DealerName}
                          </td>
                          <td
                            onClick={() =>
                              viewRetailerScorecardScreen(
                                item.PFIDealerID,
                                item.PFIAPOFacilityID,
                                item.PFIBrandID,
                                item.SectionID,
                                approvedMonth,
                                item.NumericYear
                              )
                            }
                          >
                            {item.FacilityName}
                          </td>
                          <td>{item.FacilityTypeName}</td>
                          <td>{item.FIMSCode}</td>
                          <td className="b-black">{item.KPIName}</td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-2" : "cl-col-1"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.AprCL}>
                                  {item.AprVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.AprCL}>
                                {item.Apr}
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-3" : "cl-col-2"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.MayCL}>
                                  {item.MayVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.MayCL}>
                                {item.May}
                              </span>
                              <span
                                className={`${
                                  item.May - item.Apr < 0 && "ArrowDown"
                                }
                                ${item.May - item.Apr > 0 && "ArrowUp"}
                                ${item.May - item.Apr === 0 && "ArrowNone"}
                                `}
                              >
                                {item.May - item.Apr !== 0 && (
                                  <img
                                    src={
                                      item.May - item.Apr < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.May - item.Apr === 0
                                    ? "-"
                                    : Math.abs(item.May - item.Apr)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-3" : "cl-col-2"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.JunCL}>
                                  {item.JunVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.JunCL}>
                                {item.Jun}
                              </span>
                              <span
                                className={`${
                                  item.Jun - item.May < 0 && "ArrowDown"
                                }
                                ${item.Jun - item.May > 0 && "ArrowUp"}
                                ${item.Jun - item.May === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Jun - item.May !== 0 && (
                                  <img
                                    src={
                                      item.Jun - item.May < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Jun - item.May === 0
                                    ? "-"
                                    : Math.abs(item.Jun - item.May)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-3" : "cl-col-2"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.JulCL}>
                                  {item.JulVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.JulCL}>
                                {item.Jul}
                              </span>
                              <span
                                className={`${
                                  item.Jul - item.Jun < 0 && "ArrowDown"
                                }
                                ${item.Jul - item.Jun > 0 && "ArrowUp"}
                                ${item.Jul - item.Jun === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Jul - item.Jun !== 0 && (
                                  <img
                                    src={
                                      item.Jul - item.Jun < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Jul - item.Jun === 0
                                    ? "-"
                                    : Math.abs(item.Jul - item.Jun)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-3" : "cl-col-2"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.AugCL}>
                                  {item.AugVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.AugCL}>
                                {item.Aug}
                              </span>
                              <span
                                className={`${
                                  item.Aug - item.Jul < 0 && "ArrowDown"
                                }
                                ${item.Aug - item.Jul > 0 && "ArrowUp"}
                                ${item.Aug - item.Jul === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Aug - item.Jul !== 0 && (
                                  <img
                                    src={
                                      item.Aug - item.Jul < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Aug - item.Jul === 0
                                    ? "-"
                                    : Math.abs(item.Aug - item.Jul)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-3" : "cl-col-2"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.SepCL}>
                                  {item.SepVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.SepCL}>
                                {item.Sep}
                              </span>
                              <span
                                className={`${
                                  item.Sep - item.Aug < 0 && "ArrowDown"
                                }
                                ${item.Sep - item.Aug > 0 && "ArrowUp"}
                                ${item.Sep - item.Aug === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Sep - item.Aug !== 0 && (
                                  <img
                                    src={
                                      item.Sep - item.Aug < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Sep - item.Aug === 0
                                    ? "-"
                                    : Math.abs(item.Sep - item.Aug)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-3" : "cl-col-2"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.OctCL}>
                                  {item.OctVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.OctCL}>
                                {item.Oct}
                              </span>
                              <span
                                className={`${
                                  item.Oct - item.Sep < 0 && "ArrowDown"
                                }
                                ${item.Oct - item.Sep > 0 && "ArrowUp"}
                                ${item.Oct - item.Sep === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Oct - item.Sep !== 0 && (
                                  <img
                                    src={
                                      item.Oct - item.Sep < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Oct - item.Sep === 0
                                    ? "-"
                                    : Math.abs(item.Oct - item.Sep)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-3" : "cl-col-2"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.NovCL}>
                                  {item.NovVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.NovCL}>
                                {item.Nov}
                              </span>
                              <span
                                className={`${
                                  item.Nov - item.Oct < 0 && "ArrowDown"
                                }
                                ${item.Nov - item.Oct > 0 && "ArrowUp"}
                                ${item.Nov - item.Oct === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Nov - item.Oct !== 0 && (
                                  <img
                                    src={
                                      item.Nov - item.Oct < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Nov - item.Oct === 0
                                    ? "-"
                                    : Math.abs(item.Nov - item.Oct)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-3" : "cl-col-2"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.DecCL}>
                                  {item.DecVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.DecCL}>
                                {item.Dec}
                              </span>
                              <span
                                className={`${
                                  item.Dec - item.Nov < 0 && "ArrowDown"
                                }
                                ${item.Dec - item.Nov > 0 && "ArrowUp"}
                                ${item.Dec - item.Nov === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Dec - item.Nov !== 0 && (
                                  <img
                                    src={
                                      item.Dec - item.Nov < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Dec - item.Nov === 0
                                    ? "-"
                                    : Math.abs(item.Dec - item.Nov)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-3" : "cl-col-2"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.JanCL}>
                                  {item.JanVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.JanCL}>
                                {item.Jan}
                              </span>
                              <span
                                className={`${
                                  item.Jan - item.Nov < 0 && "ArrowDown"
                                }
                                ${item.Jan - item.Dec > 0 && "ArrowUp"}
                                ${item.Jan - item.Dec === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Jan - item.Dec !== 0 && (
                                  <img
                                    src={
                                      item.Jan - item.Dec < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Jan - item.Dec === 0
                                    ? "-"
                                    : Math.abs(item.Jan - item.Dec)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-3" : "cl-col-2"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.FebCL}>
                                  {item.FebVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.FebCL}>
                                {item.Feb}
                              </span>
                              <span
                                className={`${
                                  item.Feb - item.Jan < 0 && "ArrowDown"
                                }
                                ${item.Feb - item.Jan > 0 && "ArrowUp"}
                                ${item.Feb - item.Jan === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Feb - item.Jan !== 0 && (
                                  <img
                                    src={
                                      item.Feb - item.Jan < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Feb - item.Jan === 0
                                    ? "-"
                                    : Math.abs(item.Feb - item.Jan)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div
                              className={`flex-div ${
                                typeID === 1 ? "cl-col-3" : "cl-col-2"
                              }`}
                            >
                              {typeID === 1 && (
                                <span className={"ScoreCategory" + item.MarCL}>
                                  {item.MarVal}
                                </span>
                              )}
                              <span className={"ScoreCategory" + item.MarCL}>
                                {item.Mar}
                              </span>
                              <span
                                className={`${
                                  item.Mar - item.Feb < 0 && "ArrowDown"
                                }
                                ${item.Mar - item.Feb > 0 && "ArrowUp"}
                                ${item.Mar - item.Feb === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Mar - item.Feb !== 0 && (
                                  <img
                                    src={
                                      item.Mar - item.Feb < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Mar - item.Feb === 0
                                    ? "-"
                                    : Math.abs(item.Mar - item.Feb)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <span
                              className={`${
                                typeID > 2
                                  ? "ScoreCategory" + item.RankQ1CL
                                  : ""
                              }
                              `}
                            >
                              {item.Q1}
                            </span>
                          </td>
                          <td className="b-black">
                            <div className="flex-div cl-col-2">
                              <span
                                className={`${
                                  typeID > 2
                                    ? "ScoreCategory" + item.RankQ2CL
                                    : ""
                                }
                              `}
                              >
                                {item.Q2}
                              </span>
                              <span
                                className={`${
                                  item.Q2 - item.Q1 < 0 && "ArrowDown"
                                }
                                ${item.Q2 - item.Q1 > 0 && "ArrowUp"}
                                ${item.Q2 - item.Q1 === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Q2 - item.Q1 !== 0 && (
                                  <img
                                    src={
                                      item.Q2 - item.Q1 < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Q2 - item.Q1 === 0
                                    ? "-"
                                    : Math.abs(item.Q2 - item.Q1)}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td className="b-black">
                            <div className="flex-div cl-col-3">
                              <span
                                className={`${
                                  typeID > 2
                                    ? "ScoreCategory" + item.RankQ3CL
                                    : ""
                                }
                              `}
                              >
                                {item.Q3}
                              </span>
                              <span
                                className={`${
                                  item.Q3 - item.Q2 < 0 && "ArrowDown"
                                }
                                ${item.Q3 - item.Q2 > 0 && "ArrowUp"}
                                ${item.Q3 - item.Q2 === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Q3 - item.Q2 !== 0 && (
                                  <img
                                    src={
                                      item.Q3 - item.Q2 < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Q3 - item.Q2 === 0
                                    ? "-"
                                    : Math.abs(item.Q3 - item.Q2)}
                                </span>
                              </span>

                              <span
                                className={`${
                                  item.Q3 - item.Q1 < 0 && "ArrowDown"
                                }
                                ${item.Q3 - item.Q1 > 0 && "ArrowUp"}
                                ${item.Q3 - item.Q1 === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Q3 - item.Q1 !== 0 && (
                                  <img
                                    src={
                                      item.Q3 - item.Q1 < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Q3 - item.Q1 === 0
                                    ? "-"
                                    : Math.abs(item.Q3 - item.Q1)}
                                </span>
                              </span>
                            </div>
                          </td>

                          <td className="b-black">
                            <div className="flex-div cl-col-3">
                              <span
                                className={`${
                                  typeID > 2
                                    ? "ScoreCategory" + item.RankQ4CL
                                    : ""
                                }
                              `}
                              >
                                {item.Q4}
                              </span>
                              <span
                                className={`${
                                  item.Q4 - item.Q3 < 0 && "ArrowDown"
                                }
                                ${item.Q4 - item.Q3 > 0 && "ArrowUp"}
                                ${item.Q4 - item.Q3 === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Q4 - item.Q3 !== 0 && (
                                  <img
                                    src={
                                      item.Q4 - item.Q3 < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Q4 - item.Q3 === 0
                                    ? "-"
                                    : Math.abs(item.Q4 - item.Q3)}
                                </span>
                              </span>

                              <span
                                className={`${
                                  item.Q4 - item.Q1 < 0 && "ArrowDown"
                                }
                                ${item.Q4 - item.Q1 > 0 && "ArrowUp"}
                                ${item.Q4 - item.Q1 === 0 && "ArrowNone"}
                                `}
                              >
                                {item.Q4 - item.Q1 !== 0 && (
                                  <img
                                    src={
                                      item.Q4 - item.Q1 < 0
                                        ? "images/arrow-down.svg"
                                        : "images/arrow-up.svg"
                                    }
                                    width="13px"
                                    height="15px"
                                    alt="B"
                                  />
                                )}

                                <span className="no-padding">
                                  {item.Q4 - item.Q1 === 0
                                    ? "-"
                                    : Math.abs(item.Q4 - item.Q1)}
                                </span>
                              </span>
                            </div>
                          </td>

                          <td
                            className={`${
                              typeID > 2 ? "ScoreCategory" + item.RankYTDCL : ""
                            }
                              `}
                          >
                            <div>
                              <span>{item.YTD}</span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrendReport;
